module.exports = __webpack_public_path__ + "media/components/Influencers/Oauths/New/StepPage/step3_2-30874cf897fb64010ba777305defd880.png";